import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';
import {
  buildScheduleLines,
  getBranchFullAddress,
  getBranchLatitude,
  getBranchLongitude,
  PromotionBranchLike,
  ScheduleLineView,
} from '../promotion-display.util';

@Component({
  selector: 'app-promo-branch-panel',
  templateUrl: './promo-branch-panel.component.html',
  styleUrls: ['./promo-branch-panel.component.scss'],
})
export class PromoBranchPanelComponent implements AfterViewInit, OnChanges {
  @ViewChild('map') mapElement: { nativeElement: HTMLElement } | undefined;

  @Input() branch: PromotionBranchLike | undefined;

  scheduleLines: ScheduleLineView[] = [];
  fullAddress = '';
  branchName = '';

  private map: google.maps.Map | undefined;
  private marker: google.maps.marker.AdvancedMarkerElement | undefined;
  private mapRequestId = 0;

  constructor(
    private readonly googleMapsLoader: GoogleMapsLoaderService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['branch']) {
      this.refreshBranchView();
      if (this.mapElement?.nativeElement) {
        void this.initMap();
      }
    }
  }

  ngAfterViewInit(): void {
    this.refreshBranchView();
    void this.initMap();
  }

  private refreshBranchView(): void {
    this.branchName =
      this.branch?.branchName?.trim() || this.branch?.name?.trim() || '';
    this.fullAddress = getBranchFullAddress(this.branch);
    this.scheduleLines = buildScheduleLines(this.branch);
  }

  private async initMap(): Promise<void> {
    this.cdr.detectChanges();

    const element = this.mapElement?.nativeElement;
    if (!element) {
      return;
    }

    const lat = getBranchLatitude(this.branch);
    const lng = getBranchLongitude(this.branch);
    if (!lat && !lng) {
      return;
    }

    const requestId = ++this.mapRequestId;

    try {
      if (this.marker) {
        this.marker.map = null;
        this.marker = undefined;
      }

      const { map, marker } = await this.googleMapsLoader.createBranchMap({
        element,
        latitude: lat,
        longitude: lng,
        title: this.branchName,
      });

      if (requestId !== this.mapRequestId) {
        marker.map = null;
        return;
      }

      this.map = map;
      this.marker = marker;
    } catch (error) {
      console.error('Error al inicializar el mapa de sucursal en promo:', error);
    }
  }
}
